import * as React from 'react';
import type { SVGProps } from 'react';
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <rect width={12} height={1.5} x={5} y={4} fill="currentColor" rx={0.75} />
    <rect width={12} height={1.5} x={5} y={7.5} fill="currentColor" rx={0.75} />
    <rect width={12} height={1.5} x={5} y={11} fill="currentColor" rx={0.75} />
    <rect
      width={12}
      height={1.5}
      x={5}
      y={14.5}
      fill="currentColor"
      rx={0.75}
    />
    <circle cx={2.75} cy={4.75} r={0.75} fill="currentColor" />
    <circle cx={2.75} cy={8.25} r={0.75} fill="currentColor" />
    <circle cx={2.75} cy={11.75} r={0.75} fill="currentColor" />
    <circle cx={2.75} cy={15.25} r={0.75} fill="currentColor" />
  </svg>
);
export default SvgList;
